import React from 'react';
import { Instagram, MapPin, Phone } from 'lucide-react';
import { FaWhatsapp } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-section">
          <h3 className="footer-brand">The Heaven Town Homestay</h3>
          <p className="body-small footer-description">
            Your sanctuary in the hills. Experience peace, comfort, and natural beauty.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Contact</h4>
          <div className="footer-links">
            <a href="tel:+91 95966 46409" className="footer-link">
              <Phone size={16} />
              <span>+91 95966 46409</span>
            </a>
            <a href="https://wa.me/919596646409" target="_blank" rel="noopener noreferrer" className="footer-link">
              <FaWhatsapp size={16} />
              <span>WhatsApp</span>
            </a>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Follow Us</h4>
          <div className="footer-social">
            <a href="https://www.instagram.com/the_heaventown?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noopener noreferrer" className="social-icon">
              <Instagram size={20} />
            </a>
            <a href="https://maps.app.goo.gl/ZWty2A3cKbQv6Rhb8" target="_blank" rel="noopener noreferrer" className="social-icon">
              <MapPin size={20} />
            </a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p className="body-small">© 2025 The Heaven Town Homestay | Designed with peace</p>
      </div>
    </footer>
  );
};

export default Footer;
